import { countries } from '../consts/countries';

/**
 * Converts a given 2-letter country code to its corresponding flag emoji.
 *
 * @param country - The 2-letter country code (ISO 3166-1 alpha-2). If null, returns an empty string.
 * @returns The flag emoji corresponding to the given country code.
 * @throws Will throw an error if the country code is not exactly 2 characters long.
 * @throws Will throw an error if the country code is not found in the list of valid countries.
 */
export const getFlagEmoji = (country: string | null): string => {
  if (country == null) return '';
  if (country.length !== 2) throw new Error('Invalid country code');
  if (countries.find(({ code }) => country.toUpperCase() === code) == null)
    throw new Error('Country not found');

  return country
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397));
};
